import {useEffect, useState} from 'react';

interface SessionData {
  isAuthV2: boolean;
  expireIn: number;
  refreshToken: string;
  sessionId: string;
}

interface SessionState {
  id?: string;
  refreshToken?: string;
  expireAt?: number;
}

export function useSessionData(isSessionRefresh: string) {
  const [sessionData, setSessionData] = useState<SessionData>({
    isAuthV2: false,
    expireIn: 0,
    refreshToken: '',
    sessionId: ''
  });
  useEffect(() => {
    const loginType = typeof window !== 'undefined' && sessionStorage.getItem('loginType');
    const sessionStateFromStored: SessionState | null =
      typeof window !== 'undefined' ? (JSON.parse(sessionStorage.getItem('session') || '{}') as SessionState) : null;
    const isAuthV2 = ['OH_AUTH'].includes((loginType as string) || '');
    const session = isAuthV2 ? sessionStateFromStored : null;
    const refreshToken = isAuthV2 ? session?.refreshToken : '';
    const expireIn = isAuthV2 ? (session?.expireAt ?? 0) : 0;
    setSessionData({
      isAuthV2,
      expireIn,
      refreshToken: refreshToken ?? '',
      sessionId: session?.id ?? ''
    });
    return function cleanup() {
      setSessionData({
        isAuthV2: false,
        expireIn: 0,
        refreshToken: '',
        sessionId: ''
      });
    };
  }, [isSessionRefresh]);
  return {
    isAuthV2: sessionData.isAuthV2,
    expireIn: sessionData.expireIn,
    refreshToken: sessionData.refreshToken,
    sessionId: sessionData.sessionId
  };
}
